(function () {
  'use strict';
  const configNode = document.getElementById('BlackGiftSelectionConfig');
  const R = window.MisakiBlackGiftSelectionRules;
  if (!configNode || !R) return;
  const config = JSON.parse(configNode.textContent);
  const products = config.products;
  const keys = ['cloth', 'oil'];
  const stateKey = 'misaki-black-gift-cart-selection-2026';
  const popupKey = 'misaki-black-gift-popup-shown-2026';
  const accessKey = 'misaki-black-gift-cart-enrolled-2026';
  const testKey = 'misaki-black-gift-cart-test-2026';
  const entryKey = 'misaki-black-gift-email-entry-session';
  const root = config.root.replace(/\/$/, '') + '/';
  const views = [...document.querySelectorAll('[data-bg-selection]')];
  let cart = null, state = null, busy = false, error = '', tail = Promise.resolve();
  let checkoutPass = false, storageOK = true, expirationQueued = false;
  let lastRender = '', popupOpened = false;
  let pendingGift = null; // Display only; never used to decide cart changes.
  function read(storage, key) { try { return JSON.parse(storage.getItem(key)); } catch (_) { return null; } }
  function write(storage, key, value) {
    try { storage.setItem(key, JSON.stringify(value)); return true; }
    catch (_) { storageOK = false; return false; }
  }
  const emailEntry = new URLSearchParams(location.search).get('black_gift_source') === 'email';
  if (emailEntry) {
    write(sessionStorage, entryKey, true);
    // Carry campaign access into other shop tabs, just like a successful popup signup.
    write(localStorage, accessKey, { until: Math.max(R.campaignEnd, Date.now() + 14400000) });
  }
  function enrolled() {
    const access = read(localStorage, accessKey);
    const email = read(sessionStorage, 'misaki-black-gift-email-session');
    return config.customerSubscribed === true || read(sessionStorage, entryKey) === true || (access?.until > Date.now())
      || (typeof email?.email === 'string' && email.email.includes('@') && Date.now() - email.savedAt < 14400000);
  }
  function active() { return read(sessionStorage, testKey) === true || (config.public && R.campaignActive()); }
  function saved() { return read(localStorage, stateKey); }
  function save() {
    if (!state || !cart) return;
    write(localStorage, stateKey, { cartId: cartId(cart), selected: state.selected, expiresAt: state.expiresAt });
  }
  function cartId(value) { return String(value.token || '').split('?')[0]; }
  function hasDiscount(value) {
    return value.items.some(item => !R.giftKind(item, products) && !item.properties?._black_gift_attempt && (item.total_discount > 0 || item.line_level_discount_allocations?.length))
      || value.cart_level_discount_applications?.length > 0
      || value.discount_codes?.some(code => code.applicable && !code.code.toUpperCase().startsWith('BG26-'));
  }
  function hydrate(value) {
    cart = value;
    const stored = saved();
    const own = stored?.cartId === cartId(cart) && cartId(cart) ? stored : {};
    state = R.reconcile({
      amount: R.purchaseAmount(cart.items, keys.map(key => String(products[key].id))),
      currency: cart.currency, active: active(), enrolled: enrolled(),
      selected: Array.isArray(own.selected) ? own.selected : [],
      expiresAt: Number.isFinite(own.expiresAt) ? own.expiresAt : null,
      stock: Object.fromEntries(keys.map(key => [key, products[key].available && products[key].id && products[key].price === 0]))
    });
    if (hasDiscount(cart)) state.selected = [];
  }
  async function request(path, body) {
    const response = await fetch(root + path, {
      method: body ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store',
      headers: { Accept: 'application/json', ...(body ? { 'Content-Type': 'application/json' } : {}) },
      ...(body ? { body: JSON.stringify(body) } : {}), signal: AbortSignal.timeout(15000)
    });
    if (!response.ok) throw new Error('cart-request');
    return response.json();
  }
  async function refreshCartMarkup() {
    // Wait for Impulse to replace its line markup before the normal form may submit
    // updates[]. Otherwise an expired gift could shift the paid quantities by one line.
    const expected = cart.items.map(item => [item.key, item.quantity]);
    const rebuilds = [...document.querySelectorAll('#CartPageForm [data-products], #CartDrawerForm [data-products]')].map(container => new Promise((resolve, reject) => {
      let timeout;
      const observer = new MutationObserver(() => {
        const rows = [...container.querySelectorAll('.cart__item[data-key]')].map(row => [row.dataset.key, Number(row.querySelector('[name="updates[]"]')?.value)]);
        if (JSON.stringify(rows) !== JSON.stringify(expected)) return;
        clearTimeout(timeout); observer.disconnect(); resolve();
      });
      observer.observe(container, { childList: true, subtree: true });
      timeout = setTimeout(() => { observer.disconnect(); reject(new Error('cart-render-timeout')); }, 10000);
    }));
    document.dispatchEvent(new CustomEvent('cart:build'));
    await Promise.all(rebuilds);
    const section = document.querySelector('[data-bg-cart-section]');
    if (!section) return;
    // Preserve CartForm's cached subtotal and product nodes. Only refresh surrounding totals and header.
    const url = new URL(config.cartUrl, location.origin);
    url.searchParams.set('section_id', section.dataset.bgCartSection);
    // Existing storefront fetch integrations expect a URL string.
    const response = await fetch(url.toString(), { credentials: 'same-origin', cache: 'no-store', signal: AbortSignal.timeout(15000) });
    if (!response.ok) throw new Error('cart-markup');
    const fresh = new DOMParser().parseFromString(await response.text(), 'text/html');
    const header = section.querySelector('.section-header');
    const nextHeader = fresh.querySelector('.section-header');
    if (header && nextHeader) header.replaceWith(nextHeader);
    const totals = section.querySelector('#cart-totals-extra');
    if (totals) {
      totals.querySelectorAll('.cart__row').forEach(row => row.remove());
      fresh.querySelectorAll('#cart-totals-extra > .cart__row').forEach(row => totals.insertBefore(row, totals.querySelector('.cart__item-sub')));
    }
    const form = document.getElementById('CartPageForm');
    if (form) form.hidden = !cart.item_count;
    // An initially empty cart has no CartForm instance. A later external add needs a normal page load.
    else if (cart.item_count) location.reload();
  }
  async function transaction(action) {
    const previousCart = cart ? JSON.stringify(cart.items.map(item => [item.key, item.quantity, item.final_line_price])) : null;
    hydrate(await request('cart.js'));
    // Session testing in one tab must not let an inactive tab erase its selection.
    // Explicit deactivation and normal checkout still reconcile the shared cart.
    if (!config.public && !active() && !action?.forceCleanup) return;
    if (action?.type === 'select' && !hasDiscount(cart) && storageOK) state = R.select(state, action.gift);
    if (action?.type === 'renew' && storageOK) state = R.reactivate(state);
    if (action?.type === 'remove') state.selected = state.selected.filter(key => String(products[key].id) !== action.id);
    save();
    if (!storageOK) state.selected = [];
    let changed = false;
    // Retire only legacy Black Gift codes, preserving all unrelated discount codes.
    if (cart.discount_codes?.some(code => code.code.toUpperCase().startsWith('BG26-'))) {
      await request('cart/update.js', { discount: cart.discount_codes.filter(code => !code.code.toUpperCase().startsWith('BG26-')).map(code => code.code).join(',') });
      changed = true;
    }
    for (let attempt = 0; attempt < 4; attempt++) {
      hydrate(await request('cart.js'));
      if (!storageOK) state.selected = [];
      save();
      const plan = R.changes(cart, state, products);
      if (Object.keys(plan.updates).length) {
        // Change by line key, not variant ID: paid accessories can never be touched by this operation.
        for (const [id, quantity] of Object.entries(plan.updates)) await request('cart/change.js', { id, quantity });
        changed = true;
        continue;
      }
      if (plan.missing.length) {
        await request('cart/add.js', { items: plan.missing.map(key => ({
          id: products[key].id, quantity: 1,
          properties: { _black_gift_cart_v2: key, _black_gift_expires_at: String(state.expiresAt) }
        })) });
        changed = true;
        continue;
      }
      if (changed || previousCart !== JSON.stringify(cart.items.map(item => [item.key, item.quantity, item.final_line_price]))) await refreshCartMarkup();
      return;
    }
    throw new Error('cart-not-settled');
  }
  function sync(action) {
    const run = async () => {
      const gift = action?.type === 'select' ? action.gift
        : action?.type === 'remove' ? keys.find(key => String(products[key].id) === action.id) : null;
      pendingGift = gift ? { key: gift, label: action.type === 'remove' || state?.selected.includes(gift) ? 'removing' : 'adding' } : null;
      busy = true; error = ''; render();
      try {
        if (navigator.locks) await navigator.locks.request('misaki-black-gift-cart-2026', () => transaction(action));
        else await transaction(action);
      } catch (_) {
        error = t('error');
        // Never blindly retry an ambiguous add. Read back before the next deliberate retry.
        try { hydrate(await request('cart.js')); } catch (_) { /* Keep last known state and block normal checkout. */ }
      } finally { busy = false; pendingGift = null; expirationQueued = false; render(); }
      return !error;
    };
    tail = tail.then(run, run);
    return tail;
  }
  function t(key, values = {}) {
    return Object.entries(values).reduce((text, [name, value]) => text.replaceAll('{' + name + '}', value), config.copy[key] || key);
  }
  function money(cents) { return 'CHF ' + (cents / 100).toFixed(cents % 100 ? 2 : 0); }
  function escape(value) { return String(value).replace(/[&<>"']/g, ch => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch])); }
  function renderHeader(enabled, view, conflict) {
    document.querySelectorAll('[data-bg-header]').forEach(node => {
      node.hidden = !enabled || !enrolled() || !view;
      if (node.hidden) return;
      const qualified = R.qualifyingAmount(view.amount);
      const next = R.tiers.find(value => value > qualified);
      const message = error || (!storageOK ? t('error') : conflict ? t('conflict') : view.expired ? t('expired') : view.currency !== 'CHF' ? t('currency') : next ? t(next === 40000 ? 'remaining_both' : 'remaining', { amount: money(next - qualified) }) : t('all_unlocked'));
      const title = view.selected.length ? view.selected.map(key => t(key)).join(' + ') : t('title');
      const set = (selector, value) => node.querySelectorAll(selector).forEach(element => { if (element.textContent !== value) element.textContent = value; });
      set('[data-gift-title]', title);
      set('[data-gift-message], [data-gift-mobile-detail], [data-gift-short]', message);
      set('[data-gift-stage]', `· ${R.tiers.filter(tier => view.currency === 'CHF' && qualified >= tier).length}/${R.tiers.length}`);
      set('[data-gift-amount]', view.currency === 'CHF' ? money(view.amount) : view.currency);
      set('[data-gift-link-label], [data-gift-link-short]', t('cart_label'));
      node.querySelector('[data-gift-link]').href = config.cartUrl;
      node.querySelector('[data-gift-link]').classList.add('is-ready');
      node.classList.add('is-ready');
      node.querySelector('progress').value = view.currency === 'CHF' ? qualified : 0;
      R.tiers.forEach((tier, index) => {
        const previous = R.tiers[index - 1] || 0;
        const fraction = view.currency === 'CHF' ? Math.max(0, Math.min(1, (qualified - previous) / (tier - previous))) : 0;
        node.querySelectorAll(`[data-gift-segment="${tier}"] [data-gift-fill]`).forEach(fill => { fill.style.width = `${fraction * 100}%`; });
        node.querySelector(`[data-gift-tier="${tier}"]`).classList.toggle('is-reached', view.currency === 'CHF' && qualified >= tier);
      });
    });
  }
  function render() {
    const enabled = active();
    const visible = enabled && enrolled();
    document.getElementById('CartDrawer')?.classList.toggle('bg-selection-enabled', visible);
    document.querySelectorAll('[data-bg-banner]').forEach(node => { node.hidden = !enabled || visible; });
    document.querySelectorAll('[data-bg-signup-status]').forEach(node => {
      node.hidden = !error;
      node.textContent = error;
    });
    const test = document.querySelector('[data-bg-test]');
    if (test) { test.hidden = config.public; test.textContent = t(read(sessionStorage, testKey) ? 'test_off' : 'test_on'); }
    if (!visible) {
      renderHeader(enabled, null, false);
      views.forEach(node => { node.hidden = true; node.innerHTML = ''; });
      lastRender = '';
      return;
    }
    if (!state) { renderHeader(enabled, null, false); views.forEach(node => { node.hidden = !enabled; node.textContent = error || t('updating'); }); return; }
    const view = R.reconcile({ ...state, active: enabled, enrolled: enrolled() });
    if (error) view.selected = view.selected.filter(key => cart.items.some(item => R.giftKind(item, products) === key && item.final_line_price === 0));
    const conflict = hasDiscount(cart);
    renderHeader(enabled, view, conflict);
    const qualified = R.qualifyingAmount(view.amount);
    const next = R.tiers.find(value => value > qualified);
    const signature = JSON.stringify([view.amount, view.currency, view.selected, view.expiresAt, view.expired, view.enrolled, view.active, busy, pendingGift, error, conflict]);
    if (signature !== lastRender) {
      lastRender = signature;
      const focused = document.activeElement?.dataset.bgSelect;
      const html = `<div class="bg-top"><h2>${escape(t('title'))}</h2></div>
        <p class="bg-progress-copy">${escape(view.currency !== 'CHF' ? t('currency') : next ? t(next === 40000 ? 'remaining_both' : 'remaining', { amount: money(next - qualified) }) : t('all_unlocked'))}</p>
        <div class="bg-track" aria-label="${escape(t('title'))}">${R.tiers.map((tier, index) => {
          const fraction = Math.max(0, Math.min(1, (qualified - (R.tiers[index - 1] || 0)) / (tier - (R.tiers[index - 1] || 0))));
          return `<div class="bg-stage ${qualified >= tier ? 'is-reached' : ''}"><div class="bg-rail"><i style="transform:scaleX(${fraction})"></i></div><strong>${qualified >= tier ? '✓ ' : ''}${money(tier)}</strong><span>${escape(t(['stage_cloth', 'stage_choice', 'stage_both'][index]))}</span></div>`;
        }).join('')}</div>
        <div class="bg-selection-head"><h3>${escape(t('choose'))}</h3><span ${view.limit ? '' : 'hidden'}>${escape(t('count', { count: view.selected.length, limit: view.limit }))}</span></div>
        <div class="bg-cards">${keys.map(key => {
          const threshold = key === 'cloth' ? 10000 : 25000;
          const locked = !view.unlocked.includes(key);
          const chosen = view.selected.includes(key);
          const available = !!view.stock[key];
          const pending = busy && pendingGift?.key === key;
          const disabled = locked || !available || !view.enrolled || busy || !!error || conflict || !storageOK;
          return `<button type="button" data-bg-select="${key}" class="bg-card ${locked || !available ? 'is-locked' : ''} ${pending ? 'is-pending' : ''}" aria-pressed="${chosen}" aria-busy="${pending}" ${disabled ? 'disabled' : ''}>
            <span class="bg-image">${products[key].image ? `<img src="${escape(products[key].image)}" alt="" width="640" height="480" loading="lazy">` : ''}</span><span class="bg-check" aria-hidden="true">${pending ? '<span class="bg-spinner"></span>' : locked || !available ? '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75"><rect x="5" y="10" width="14" height="11" rx="2"/><path d="M8 10V7a4 4 0 0 1 8 0v3M12 14v3"/></svg>' : '✓'}</span>
            <span class="bg-info"><strong>${escape(t(key))}</strong><span class="bg-price"><strong class="bg-free">${escape(t('free'))}</strong><span class="bg-value">${escape(t('value', { amount: money(products[key].value) }))}</span></span>
            <span class="bg-card-bottom"><span>${escape(pending ? t(pendingGift.label) : !available ? t('unavailable') : locked ? t('from_amount', { amount: money(threshold) }) : chosen ? t('selected') : t('available'))}</span></span></button>`;
        }).join('')}</div>
        <p class="bg-status" role="status">${escape(error || (!storageOK ? t('error') : conflict ? t('conflict') : ''))}</p>
        ${error ? `<button type="button" class="bg-action" data-bg-retry>${escape(t('retry'))}</button>` : ''}
        ${!config.public && read(sessionStorage, testKey) ? `<p class="bg-footnote">${escape(t('test_note'))}</p><button type="button" class="bg-test-toggle" data-bg-test>${escape(t('test_off'))}</button>` : ''}`;
      views.forEach(node => { node.hidden = !enabled; node.innerHTML = html; node.setAttribute('aria-busy', String(busy)); });
      if (focused && !busy) views.find(node => node.getClientRects().length)?.querySelector(`[data-bg-select="${focused}"]`)?.focus({ preventScroll: true });
    }

  }
  function signup() {
    if (!active() || enrolled()) return;
    try { localStorage.setItem(popupKey, JSON.stringify(R.campaignEnd)); } catch (_) { /* Popup storage must not block the cart. */ }
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', config.formId]);
    popupOpened = false;
    setTimeout(() => { if (!popupOpened && !enrolled()) { error = t('signup_error'); render(); } }, 8000);
  }
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (link && config.legacyUrl && link.closest(`[data-testid="klaviyo-form-${config.formId}"]`)) {
      const target = new URL(link.href, location.origin);
      if (target.origin === location.origin && target.pathname === new URL(config.legacyUrl, location.origin).pathname) {
        event.preventDefault();
        location.assign(config.cartUrl);
        return;
      }
    }
    const button = event.target.closest('button');
    if (!button) return;
    if (button.hasAttribute('data-bg-header-toggle')) {
      const header = button.closest('[data-bg-header]');
      if (header) button.setAttribute('aria-expanded', String(header.classList.toggle('is-expanded')));
    }
    if (button.hasAttribute('data-bg-signup')) signup();
    if (button.dataset.bgSelect && !busy) sync({ type: 'select', gift: button.dataset.bgSelect });
    if (button.dataset.bgRemove && !busy) sync({ type: 'remove', id: button.dataset.bgRemove });
    if (button.hasAttribute('data-bg-retry') && !busy) sync();
    if (button.hasAttribute('data-bg-test')) {
      write(sessionStorage, testKey, !read(sessionStorage, testKey));
      if (document.querySelector('[data-bg-gateway]') && active()) location.assign(config.cartUrl);
      else sync({ forceCleanup: !active() });
    }
  });
  window.addEventListener('klaviyoForms', event => {
    const detail = event.detail || {};
    if (detail.formId !== config.formId) return;
    if (detail.type === 'open') {
      popupOpened = true;
      try { localStorage.setItem(popupKey, JSON.stringify(R.campaignEnd)); } catch (_) { /* Keep the cart usable. */ }
    }
    if (detail.type === 'submit') {
      write(localStorage, accessKey, { until: Math.max(R.campaignEnd, Date.now() + 14400000) });
      sync().then(() => {
        const visibleCart = views.find(node => node.getClientRects().length);
        if (!visibleCart) return;
        const form = document.querySelector(`[data-testid="klaviyo-form-${config.formId}"]`);
        form?.closest('[role="dialog"]')?.querySelector('button[aria-label="Close dialog"]')?.click();
        visibleCart.querySelector('[data-bg-select]:not(:disabled)')?.focus({ preventScroll: true });
      });
    }
  });
  document.addEventListener('submit', event => {
    if (!event.target.matches('#CartPageForm, #CartDrawerForm') || !event.submitter?.matches('[name="checkout"]')) return;
    if (checkoutPass) { checkoutPass = false; return; }
    if (!active() && !cart?.items.some(item => R.giftKind(item, products) || item.properties?._black_gift_attempt || item.properties?._black_gift_cart_v2)) return;
    event.preventDefault(); event.stopImmediatePropagation();
    const form = event.target, submitter = event.submitter;
    sync({ forceCleanup: true }).then(ok => { if (ok) { checkoutPass = true; form.requestSubmit(submitter); } });
  }, true);
  ['cart:updated', 'ajaxProduct:added', 'drawerOpen.CartDrawer'].forEach(name => document.addEventListener(name, () => sync()));
  window.addEventListener('pageshow', () => sync());
  window.addEventListener('focus', () => sync());
  window.addEventListener('storage', event => { if ([stateKey, accessKey].includes(event.key)) { render(); sync(); } });
  setInterval(() => {
    render();
    if (!busy && !expirationQueued && state && state.active !== active()) {
      expirationQueued = true; sync();
    }
  }, 1000);
  if (document.querySelector('[data-bg-gateway]') && active() && enrolled()) location.replace(config.cartUrl);
  if (config.autoSignup && !views.length && !document.querySelector('[data-bg-gateway]')) {
    setTimeout(async () => {
      const openOnce = () => {
        const dialog = [...document.querySelectorAll('[role="dialog"], [aria-modal="true"]')].some(node => node.getClientRects().length && getComputedStyle(node).visibility !== 'hidden');
        if (active() && !enrolled() && !dialog && !read(sessionStorage, 'misaki-black-gift-cart-popup-shown') && !(read(localStorage, popupKey) > Date.now())) {
          signup();
        }
      };
      if (navigator.locks) await navigator.locks.request(popupKey, openOnce);
      else openOnce();
    }, 8000);
  }
  sync();
})();
